<template>
    <div>
    <div class="notice-float" v-show="notice_status">
        <div class="head">
            <router-link to="/notice/exam" class="tit"><el-icon><InfoFilled /></el-icon> 您当前有{{notice_num}}个通知未读。</router-link>
            <el-button circle size="small" type="warning" icon="CloseBold" @click="closeNotice" class="closebtn"></el-button>
        </div>
        <div class="con">
            <p class="p" v-for="item in notice_list" :key="item.id" @click="getNoticeInfo(item.id)">
                    {{ item.title }}
                </p>
        </div>
    </div>

    <!-- 通知详情 -->
    <Dialog
        ref="noticeDialogRef"
        :dialogObject="dialogNoticeOpt"
        @dialogClose="dialogNoticeOpt.dialogVisible = false"
    >
        <div v-html="noticeInfo"></div>
    </Dialog>
    </div>
</template>

<script>
import showMsg from "@/utils/message";
import { onBeforeUnmount, reactive, toRefs, watch } from "vue";
import { useStore } from "vuex";
import { getExamineeNoticeList, getExamineeNotice } from "@/api/common";
import Dialog from "@/components/Dialog/Dialog.vue";

export default {
  components: {
    Dialog,
  },
  setup() {
    const store = useStore();

    const state = reactive({
      notice_list: [],
      notice_num: 0,
      notice_status: false,
      timer: null,
      noticeInfo: "",
      dialogNoticeOpt: {
        dialogVisible: false,
        title: "",
        isFooter: false,
        loading: false,
      },
    })

    watch(()=>store.state.open_notice, (newVal)=>{
      if(newVal) {
        getNoreadNotice();
      }else {
        if(state.timer) {
            clearTimeout(state.timer);
        }
      }
    })
    getNoreadNotice();

    function getNoreadNotice(){
        if(state.timer) {
            clearTimeout(state.timer);
        }
        getExamineeNoticeList({is_read: 0}).then((res)=>{
            const { data } = res;
            state.notice_list = data.list;
            state.notice_num = data.total;
            state.notice_status = state.notice_list.length ? true : false;

            if(!state.notice_list.length && store.state.open_notice) {
                state.timer = setTimeout(()=>{
                    getNoreadNotice();
                }, 30 * 1000)
            }
        }).catch(()=>{})
    }

    const closeNotice = ()=>{
        store.commit('SET_NOTICE', false);
        state.notice_status = false;
        if(state.timer) {
            clearTimeout(state.timer);
        }
    }

     // 获取通知
     const getNoticeInfo = (id)=>{
        getExamineeNotice({id}).then((res)=>{
        const { data } = res;
        state.dialogNoticeOpt.title = data.title;
        state.dialogNoticeOpt.dialogVisible = true;
        state.noticeInfo = data.content;
      }).catch((err)=>{
        if(err.code == 400) showMsg.error(err.msg);
      })
    }

    onBeforeUnmount(()=>{
        if(state.timer) {
            clearTimeout(state.timer);
        }
    })

    return { 
        ...toRefs(state),
        closeNotice,
        getNoticeInfo
    };
  },

};
</script>

<style lang="less" scoped>
.notice-float {
    position: fixed;
    right: 10px;
    bottom: 10px;
    border-radius: 5px;
    width: 250px;
    background-color: @color_primary;
    color: #fff;
    padding: 20px;
    z-index: @headZindex + 1;

    .closebtn {
        position: absolute;
        top: -10px;
        right: -10px;
    }
    .head {
        .tit {
            font-size: 16px;
            margin-bottom: 15px;
            color: #fff;
            .el-icon {
                font-size: 24px;
                vertical-align: middle;
            }
        }
    }
    .con {
        .p {
            padding: 5px 0;
            border-bottom: 1px solid rgba(255,255,255, 0.5);
            cursor: pointer;
        }
    }
}
</style>